const state = () => ({
	userInformation: {
		name: '',
		phoneNumber: '',
		userId: '',
		role: 'AllUser',
		roles: [] as string[],
		activeContext: '',
		professionalId: null as string | null,
		businessId: null as string | null,
		loggedIn: false,
		city: {},
		profileImagePath: '',
	},
	businessSelected: {},
	businessInfo: {},
	artistInfo: {},
	selectedArtists: [],
	selectedArtistPreferences: [],
	artistSelectionSkipped: false,
	serviceInfo: [],
	timeInfo: {},
	bookingMode: 'Together',
	bookingSuggestion: null,
	bookingSuggestionExpiresAt: null,
	splitBookingConfirmed: false,
	redirectPathAfterLogin: '/',
});

export default state;
